import { Wind } from 'lucide-react';
import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AirQualitySection = () => {
  const [airQuality, setAirQuality] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAirQuality = async () => {
      try {
        const response = await axios.get(`${API}/air/quality`);
        setAirQuality(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching air quality:', error);
        setLoading(false);
      }
    };
    fetchAirQuality();
  }, []);

  const getAQIColor = (index) => {
    if (index <= 50) return '#4CAF50';
    if (index <= 100) return '#FFC107';
    if (index <= 150) return '#FF9800';
    return '#F44336';
  };

  return (
    <div className="content-card" data-testid="air-quality-section">
      <div className="card-header">
        <h2>
          <Wind size={20} className="inline" /> Air Quality
        </h2>
      </div>
      <div className="card-content">
        {loading ? (
          <p className="loading-text">Loading...</p>
        ) : airQuality ? (
          <div className="air-quality-container">
            <div className="aqi-display" style={{ borderColor: getAQIColor(airQuality.index) }}>
              <div className="aqi-value" style={{ color: getAQIColor(airQuality.index) }}>
                {airQuality.index}
              </div>
              <div className="aqi-level">{airQuality.level}</div>
            </div>
            <div className="aqi-details">
              <p className="aqi-pollutant">Main Pollutant: {airQuality.pollutant}</p>
              <p className="aqi-advice">{airQuality.health_advice}</p>
            </div>
          </div>
        ) : (
          <p className="no-data">Air quality data unavailable</p>
        )}
      </div>
    </div>
  );
};

export default AirQualitySection;